export default __webpack_public_path__ + "static/media/blog6.14727397.jpg";